import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Accounts from "@/views/Accounts.vue";
import Auth from "@/views/Auth.vue";
import FileSharing from "@/views/FileSharing.vue";
import DataViewer from "@/views/DataViewer.vue";
import { AuthService } from "@/services/auth.service";
import { container } from "@/services/container";
import Users from "@/views/Users.vue";
import Review from "@/views/Review.vue";
import MetadataManager from "@/views/MetadataManager.vue";
import MetadataEditor from "@/views/MetadataEditor.vue";

const authService: AuthService = container.get("authService");

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/accounts",
    name: "Accounts",
    component: Accounts,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
  },
  {
    path: "/login",
    name: "auth",
    component: Auth,
  },
  {
    path: "/file-sharing",
    name: "File Sharing",
    component: FileSharing,
  },
  {
    path: "/metadata-manager",
    name: "Metadata Manager",
    component: MetadataManager,
  },
  {
    path: "/data-viewer",
    name: "Data Viewer",
    component: DataViewer,
  },
  {
    path: "/metadata-editor",
    name: "Metadata Editor",
    component: MetadataEditor,
  },
  {
    path: "/review",
    name: "Review",
    component: Review,
  },
];

const router = new VueRouter({
  routes,
});

// Guard in Vue
router.beforeEach((to, from, next) => {
  authService
    .isAuthenticatedAsync()
    .then((x: boolean) =>
      next(
        to.name === "auth"
          ? x
            ? { name: "root" }
            : undefined
          : x
          ? undefined
          : { name: "auth" }
      )
    );
});

export default router;
